import { useCallback, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { RoundingRule } from 'repository/timekeeper/@types/RoundingRules';

export const useRoundingRulesTableState = () => {
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<RoundingRule[]>([]);
    const [selected, setSelected] = useState<GridRowSelectionModel>([]);

    const cleanSelected = useCallback(() => {
        setSelectedRow([]);
        setSelected([]);
    }, []);

    return {
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
